import { useMemo } from 'react';
import { NavigationTreeViewMultiSelect, TreeNode } from '@shared/components';
import { NodeLabel } from './NodeLabel';
import { ProductGroupCount, ProductGroup } from '@retail/products/types';

interface Props {
  productGroups: ProductGroupCount[];
  selectedProductGroups: string[];
  getCount?: (productGroup: ProductGroup) => number | undefined;
  selectProductGroup: (productGroup: string) => void;
}

export const ProductGroupsTreeViewMultiselect = ({
  selectProductGroup,
  selectedProductGroups,
  productGroups,
  getCount,
}: Props) => {
  const treeNodes: TreeNode[] = useMemo(() => {
    const overGroupsNodes = productGroups.map((productGroup) => ({
      id: productGroup.groupNumber,
      label: <NodeLabel {...productGroup} count={getCount && getCount(productGroup)} />,
      onSelect: () => selectProductGroup(productGroup.groupNumber),

      childNodes: productGroup.subGroups?.map((productGroup) => ({
        id: productGroup.groupNumber,
        label: <NodeLabel {...productGroup} count={getCount && getCount(productGroup)} />,
        onSelect: () => selectProductGroup(productGroup.groupNumber),

        childNodes: productGroup.subGroups?.map((productGroup) => ({
          id: productGroup.groupNumber,
          label: <NodeLabel {...productGroup} count={getCount && getCount(productGroup)} />,
          onSelect: () => selectProductGroup(productGroup.groupNumber),
        })),
      })),
    }));

    return overGroupsNodes;
  }, [productGroups, getCount, selectProductGroup]);

  return (
    <NavigationTreeViewMultiSelect nodes={treeNodes} selectedNodeIds={selectedProductGroups} />
  );
};
